
export type CancellationType = 'INSIDE_PERIOD_NO_CLAIMS' | 'INSIDE_PERIOD_CLAIMS' | 'OUTSIDE_PERIOD'
